<template>
  <div class="page">
    <div class="page-content">
      <div class="layoutTop"/>
       <div class="container-fluid">
         <div class="row">
           <div class="col-md-10 offset-md-1">
             <div class="panel21 panel-default">
               <div class="panel-heading">
                 <h4 class="content-block labelAccordionForm">
                   <img src="../../assets/static/images/icons/credit_cards.png" class="formIcon"/>
                   {{ $t('bank_accounts.add_bank_account') }}
                 </h4>
               </div>
               <div class="form-group row">
                 <label class="col-4 col-sm-2 col-form-label"><span class="color-red">* </span>{{ $t('common.nme') }}</label>
                 <div class="col-8 col-sm-10">
                   <input class="form-control" name="accoutName" :placeholder="$i18n.t('bank_accounts.bank_account_name')" type="text" v-model="name"></input>
                 </div>
               </div>
               <div class="form-group row">
                 <div class="col-sm-2 col-4 col-form-label labelAccordionForm">
                   <span class="color-red">* </span>
                   {{ $t('common.account_zone') }}
                 </div>
                 <div class="col-sm-4 showSmallScreenOnly form-group" :class='colorBottomButton'>
                   <div @click="countriesPicker($event)" class="button button-round button-inner-color buttonAccordionForm">
                     {{ $t('common.slct') }}
                   </div>
                 </div>
                 <div class="col-sm-12 showSmallScreenOnly">
                   <input @click="countriesPicker($event)" class="form-control"  id="ListCountry" type="text" v-model="zone" :placeholder="$i18n.t('zoneCodes.slct_zone')" readonly></input>
                 </div>
                 <div class="col-sm-10 showLargeScreenOnly">
                   <select class="form-control" id="sel4" v-model="zone" readonly>
                     <option v-for="country in countries" :key="country.id"
                      :value="country"
                      :disabled="country.disabled"
                      :selected="country.selected">
                      {{ $t(country.label) }}
                    </option>
                   </select>
                 </div>
               </div>
               <div
                 class="form-group row"
                 v-for="accountLabel in zone.accountLabel">
                   <label class="col-4 col-sm-2 col-form-label">
                     <span class="color-red">* </span>{{ $t(accountLabel) }}</label>
                   <div class="col-8 col-sm-10">
                     <input
                       name="identifier"
                       class="form-control"
                       type="text"
                       :placeholder="$i18n.t(accountLabel)"
                       v-model="zone.values[accountLabel]">
                     </input>
                   </div>
               </div>
             </div>
           </div>
         </div>
         <div class="row">
           <div class="col-md-2 offset-md-9" v-bind:class="colorBottomButton">
             <button round title="Register" class="button-action firstButtonMarginTop" @click="addAccount">
              <i class="icon fa fa-save"></i>
              <span>{{ $t('common.sve') }}</span>
             </button>
           </div>
         </div>
       </div>
     </div>
      <f7-button round title="Register" class="orangeConfirmationButton firstButtonMarginTop" @click="addAccount">Save</f7-button>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>


<script>
import {validateAccountFormat} from '@/helpers/validator'
import {createForeignIban} from '@/helpers/format'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'
import _ from 'lodash'

export default {
  name: 'AddBankAccount',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      name: '',
      zone: {
        id: 0,
        label: 'zoneCodes.slct_zone',
        disabled: true,
        selected: true
      },
      zoneCode: '',
      countries: '',
      countryPicker: ''
    }
  },
  created () {
    // DEFAULT
    // this.zone = 'EU'
    let that = this
    let label = []

    that.countries = _.cloneDeep(this.$engine.bankAccounts.getZoneCode())
    that.countries.forEach((x, y) => {
      label.push(x.label)
    })
    that.countryPicker = this.$f7.picker({
      input: '#ListCountry',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: label
        }
      ],
      onClose: function (p) {
        that.zoneCode = p.value[0]
        that.zone = _.cloneDeep(that.$engine.bankAccounts.getZoneData(p.value[0]))
      }
    })
  },
  methods: {
    addAccount () {
      let that = this

      // Check input formats
      if (this.name === '') {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.nme')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.nme')}))
        return
      }
      if (this.zone.accountNumberField == null) {
        this.$f7.alert(
            this.$i18n.t('errors.please_enter_mandatory',
              {invaliddata: this.$i18n.t('common.account_zone')}),
            this.$i18n.t('errors.missing_label',
              {invaliddata: this.$i18n.t('common.account_zone')})
        )
      }
      for (var i = 0; i < this.zone.accountNumberField; i++) {
        if (this.zone.accountLabel && this.zone.values[this.zone.accountLabel[i]] != null && this.zone.values[this.zone.accountLabel[i]]) {
          if (validateAccountFormat(this.zone.values[this.zone.accountLabel[i]], this.zone.regexControl[i]) === null) {
            this.$f7.alert(
                this.$i18n.t('errors.change_to_valid',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
                this.$i18n.t('errors.invalid_data_format',
                  {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
            )
            return
          }
        } else {
          // Account zone is mandatory
          this.$f7.alert(
              this.$i18n.t('errors.please_enter_mandatory',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])}),
              this.$i18n.t('errors.missing_label',
                {invaliddata: this.$i18n.t(this.zone.accountLabel[i])})
          )
          return
        }
      }

      // Format IBAN
      let localIban = createForeignIban(this.zone)

      // Create account
      this.$engine.bankAccounts
        .create({
          name: this.name,
          iban: localIban,
          zoneCode: this.zone.label
        })
        .then(resp => {
          this.$f7.modal({
            title: this.$i18n.t('success.added_success', {data: this.$i18n.t('common.act')}),
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            that.iban = ''
            that.name = ''
            that.zone = 'EU'
            that.sortCode = ''
            that.accountNumber = ''
            loadPage(that, {url: '/bankAccounts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
    },
    countriesPicker (e) {
      e.stopPropagation()
      this.countryPicker.open()
    }
  }
}
</script>

<style scoped>
.container {
    /* margin-right: auto;
    margin-left: auto; */
    width: 100%;
    /* margin: 0 auto; */
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}

</style>



// WEBPACK FOOTER //
// CMAddBankAccount.vue?1ad07c0c